document.addEventListener('DOMContentLoaded', function() {
    var dropdown = document.querySelector('.publications-filter-select');

    dropdown.addEventListener('change', function() {
        document.getElementById('publication_archive_filter').submit();
        console.log("Dropdown changed and form submitted.");
    });
});